import React, { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import MioOrario from './MioOrario';
import MioOrarioCel from './MioOrarioCel';
import MioOrarioC from './MioOrarioC';
import MioOrarioManutenzione from './MioOrarioManutenzione';

/**
 * Router intelligente che determina quale componente caricare
 * basandosi sul tipo di dispositivo (mobile vs desktop)
 */
const MioOrarioRouter: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Recupera le info utente per determinare il ruolo
  const [userInfo, setUserInfo] = useState<any>(() => {
    try { return JSON.parse(localStorage.getItem('userInfo') || '{}'); } catch { return {}; }
  });

  // Aggiorna su evento custom (login completato) o cambi localStorage
  useEffect(() => {
    const handler = () => {
      try { setUserInfo(JSON.parse(localStorage.getItem('userInfo') || '{}')); } catch { setUserInfo({}); }
    };
    window.addEventListener('apporari-user-changed', handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('apporari-user-changed', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  const ruolo: string = (userInfo?.ruolo || '').trim();
  const ruoloNormalized = ruolo.toLowerCase();
  const nome: string = userInfo?.nome || '';

  // Coordinatore su desktop: mostra pagina di manutenzione
  // Admin su desktop: usa MioOrarioC (vista excel-like)
  if (!isMobile && ruoloNormalized === 'coordinatore') {
    return <MioOrarioManutenzione />;
  }

  if (!isMobile && ruoloNormalized === 'admin') {
    return <MioOrarioC dipendenteNome={nome} />;
  }

  // Mobile usa versione ottimizzata esistente
  if (isMobile) return <MioOrarioCel />;

  // Fallback desktop standard (Dipendente / altri ruoli)
  return <MioOrario />;
};

export default MioOrarioRouter;
